import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Shield } from "lucide-react";
import { Footer } from "../components/Footer";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_8cb5d32c-b1ce-4951-b77e-897f98e6cc9f/artifacts/uyctypm7_41ed1e03-8bc9-42a0-8314-b43b52fec9a9.JPG";

const RULES = [
  "Debate football, do not attack people.",
  "No racism, xenophobia, tribal abuse, religious abuse, or hate speech.",
  "No personal threats, harassment, or intimidation.",
  "No spam or fake promotions.",
  "Respect rival fans.",
  "Do not post private information about other people.",
  "Keep discussions relevant to the forum category.",
  "Moderators may remove posts or suspend accounts that break the rules.",
  "Repeated abuse may lead to permanent removal.",
  "The goal is passionate African football debate without toxicity."
];

export default function ForumRulesPage() {
  useEffect(() => {
    document.title = "Forum Rules - Afro Fanthem";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-black/60 border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-3">
              <img src={LOGO_URL} alt="Afro Fanthem" className="h-10 w-auto" />
            </Link>
            <div className="flex items-center gap-4">
              <Link to="/forum" className="text-gray-300 hover:text-white text-sm transition-colors">Forum</Link>
              <Link to="/" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors" data-testid="back-home-link">
                <ArrowLeft className="w-4 h-4" />
                Home
              </Link>
            </div>
          </div>
        </div>
      </header>

      <main className="pt-24 pb-16 px-4">
        <article className="max-w-3xl mx-auto">
          <div className="flex items-center gap-4 mb-8">
            <div className="w-14 h-14 bg-[#FBBF24]/10 flex items-center justify-center flex-shrink-0">
              <Shield className="w-7 h-7 text-[#FBBF24]" />
            </div>
            <h1 className="font-heading text-4xl sm:text-5xl text-white uppercase tracking-tight" data-testid="forum-rules-headline">
              Forum Rules
            </h1>
          </div>

          <div className="bg-[#141414] border-l-4 border-[#FBBF24] p-6 sm:p-8 mb-10">
            <p className="text-gray-300 text-lg leading-relaxed">
              Afro Fanthem is built for passionate football debate, but this is not a space for hate, abuse, racism, tribal insults, harassment, or personal attacks. Argue about football. Respect the people.
            </p>
          </div>

          <div className="space-y-0">
            {RULES.map((rule, index) => (
              <div key={rule.slice(0, 20)} className={`flex gap-4 p-5 ${index % 2 === 0 ? "bg-white/[0.02]" : ""} ${index < RULES.length - 1 ? "border-b border-white/5" : ""}`}>
                <span className="font-heading text-2xl text-[#FBBF24] w-10 flex-shrink-0 text-right">{index + 1}</span>
                <p className="text-gray-300 leading-relaxed">{rule}</p>
              </div>
            ))}
          </div>

          <div className="mt-12 bg-white/5 border border-white/10 p-6 sm:p-8 text-center">
            <h2 className="font-heading text-2xl text-white uppercase mb-4">Ready to Join?</h2>
            <p className="text-gray-400 mb-6">Complete the survey or register to start debating.</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/survey" className="bg-[#FBBF24] text-black font-bold uppercase tracking-widest px-6 py-3 hover:bg-[#F59E0B] transition-all" data-testid="forum-rules-survey-cta">
                Take the Survey
              </Link>
              <Link to="/forum" className="border border-white/20 text-white font-bold uppercase tracking-widest px-6 py-3 hover:bg-white/10 transition-all" data-testid="forum-rules-forum-cta">
                View the Forum
              </Link>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-white/10">
            <Link to="/" className="inline-flex items-center gap-2 text-[#FBBF24] font-bold uppercase tracking-widest hover:gap-4 transition-all" data-testid="forum-rules-back-link">
              <ArrowLeft className="w-5 h-5" />
              Back to Homepage
            </Link>
          </div>
        </article>
      </main>

      <Footer />
    </div>
  );
}
